export default __webpack_public_path__ + "static/media/button2.8fe105c6.svg";